// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { navigationDrawerStyles } from "@stanion/Overrides/Components/NavigationDrawer";
import { buttonTransparent } from "@stanion/XDL/PreStyle/button";
import { color } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

navigationDrawerStyles.menuTriggerButton = {
    shape: "pill",
    color: "transparent",
    css: css`
        margin-right: 10px;
        padding: 6px;
        height: 30px;
        width: 30px;
        border-radius: 2px;
        ${IconWrapper} {
            color: ${color("common.ui5")};
            top: 1px !important;
        }

        ${buttonTransparent}
        ${({ isOpen }: any) =>
            isOpen &&
            css`
                &&& {
                    background-color: ${color("primary")};
                }
            `}
    `,
};

navigationDrawerStyles.drawer = {
    ...navigationDrawerStyles.drawer,
    size: 344,
};

navigationDrawerStyles.drawerSectionWrapper = {
    css: css`
        background: ${color("common.white")};
        padding: 0 10px 0 16px;
    `,
};

navigationDrawerStyles.menuRowIcon = {
    size: 22,
    css: css`
        margin-top: -2px;
        margin-right: 20px;
        width: 24px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
    `,
};

navigationDrawerStyles.mainNavigationRow = {
    color: "common.white",
    css: css`
        width: auto;
        margin: 2px;
    `,
};

navigationDrawerStyles.mainNavigationRowTypography = {
    color: "text.main",
    size: 16,
    weight: "bold",
};

navigationDrawerStyles.logoLinks = {
    color: "common.white",
    typographyProps: {
        color: "text.main",
        ellipsis: true,
        size: 16,
        weight: "bold",
    },
    css: css`
        :first-child {
            border-top: 1px solid ${color("common.ui6")};
            margin-top: 16px;
        }
        margin: 2px;
    `,
};

navigationDrawerStyles.signOutRow = {
    css: css`
        margin: 2px;
        margin-bottom: 12px;
    `,
};

navigationDrawerStyles.signOutRowText = {
    size: 14,
    weight: "bold",
    css: css`
        display: flex;
        align-items: center;
        ${IconWrapper} {
            margin-left: 8px;
        }
    `,
};

navigationDrawerStyles.fulfillmentRow = {
    css: css`
        border-bottom: 1px solid ${color("common.ui6")};
        padding-bottom: 16px;
        margin-top: 4px;
    `,
};

navigationDrawerStyles.closeIcon = {
    size: 16,
    css: css`
        fill: ${color("common.white")};
    `,
};
